import { shadow4, styled } from '@engyalo/design-system';
import { BottomNavigationAction, css, Paper, BottomNavigation } from '@mui/material';

export const CustomPaper = styled(Paper)(
  ({ theme }) => css`
    background-color: ${theme.palette.neutral.contrastText};
    border-radius: 6.5rem;
    overflow: hidden;
    width: auto;
    position: relative;

    &.fullWidth {
      width: 100%;
      border-radius: 0;
      bottom: 0;
    }
  `
);

export const CustomBottomNavigation = styled(BottomNavigation)(
  () => css`
    width: 100%;
    display: flex;
    background-color: transparent;
    padding: 0.8rem;
    &.fullWidth {
      padding: 0;
    }
  `
);

export const CustomBottomNavigationAction = styled(BottomNavigationAction)(
  ({ theme }) => css`
    height: 100%;
    flex-grow: 0;
    color: ${theme.palette.neutral.var50};
    max-width: 50%;
    flex: 1 0 0;

    &.Mui-selected {
      border-radius: 5.4rem;
      color: ${theme.palette.neutral.var0};
      background-color: ${theme.palette.neutral.var70};
      box-shadow: ${shadow4};

      &.fullWidth {
        border-radius: 0;
      }
    }

    &.fullWidth {
      flex-grow: 1;
      border-radius: 0;

      :active {
        border-radius: 0;
      }
    }

    :active {
      border-radius: 5.4rem;
      color: ${theme.palette.neutral.var0};
      background-color: ${theme.palette.neutral.var70};
      box-shadow: ${shadow4};
    }
  `
);
